var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("concentration " + (_vm.keyboardEnabled ? '' : 'full-height'))
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm.viewedIntro ? _c('div', {
    staticClass: "top",
    class: {
      isMobile: _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "card-container",
    attrs: {
      "role": "list"
    }
  }, _vm._l(_vm.currentRound.leftColumn, function (card, index) {
    return _c('flippable-card', {
      key: card.id,
      attrs: {
        "data-column": "left",
        "role": "listitem",
        "card": card,
        "callback": _vm.handleCardFlip,
        "is-flipped": card.flipped,
        "isTyping": _vm.keyboardEnabled
      }
    }, [_c('div', {
      staticClass: "back-side",
      attrs: {
        "slot": "card-back",
        "aria-hidden": card.flipped
      },
      slot: "card-back"
    }, [_c('card-border', {
      attrs: {
        "height": "65",
        "width": "220"
      }
    }), _c('img', {
      attrs: {
        "alt": ("Closed Card, Column 1, Card " + (index + 1)),
        "src": _vm.currentRound.cardBack.image.src
      }
    })], 1), _c('div', {
      staticClass: "front-side",
      attrs: {
        "slot": "card-front",
        "aria-hidden": !card.flipped
      },
      slot: "card-front"
    }, [_c('card-border', {
      attrs: {
        "height": "65",
        "width": "220"
      }
    }), _c('div', {
      staticClass: "card-text",
      attrs: {
        "aria-label": ("Open Card, Column 1, Card " + (index + 1) + ", " + (card.cardText)),
        "role": "figure"
      }
    }, [_c('span', [_vm._v(_vm._s(card.cardText))])])], 1)]);
  }), 1), _c('div', {
    staticClass: "card-container",
    attrs: {
      "role": "list"
    }
  }, _vm._l(_vm.currentRound.rightColumn, function (card, index) {
    return _c('flippable-card', {
      key: card.id,
      attrs: {
        "data-column": "right",
        "role": "listitem",
        "callback": _vm.handleCardFlip,
        "is-flipped": card.flipped,
        "card": card,
        "isTyping": _vm.keyboardEnabled
      }
    }, [_c('div', {
      staticClass: "back-side",
      attrs: {
        "slot": "card-back",
        "aria-hidden": card.flipped
      },
      slot: "card-back"
    }, [_c('card-border', {
      attrs: {
        "height": "65",
        "width": "220"
      }
    }), _c('img', {
      attrs: {
        "alt": ("Closed Card, Column 2, Card " + (index + 1)),
        "src": _vm.currentRound.cardBack.image.src
      }
    })], 1), _c('div', {
      staticClass: "front-side",
      attrs: {
        "slot": "card-front",
        "aria-hidden": !card.flipped
      },
      slot: "card-front"
    }, [_c('card-border', {
      attrs: {
        "height": "65",
        "width": "220"
      }
    }), _c('div', {
      staticClass: "card-text",
      attrs: {
        "aria-label": ("Open Card, Column 2, Card " + (index + 1) + ", " + (card.cardText)),
        "role": "figure"
      }
    }, [_c('span', [_vm._v(_vm._s(card.cardText))])])], 1)]);
  }), 1)]), _c('div', {
    staticClass: "right"
  }, _vm._l(_vm.currentRound.rightColumn, function (card, index) {
    return _c('div', {
      key: card.id,
      staticClass: "td-container"
    }, [card.matched ? _c('blinking-cursor-text', {
      key: card.id,
      attrs: {
        "text": card.answer,
        "text-step": index
      }
    }) : _vm._e()], 1);
  }), 0)]) : _vm._e(), _vm.currentRound.leftColumn && !_vm.keyboardEnabled ? _c('div', {
    class: ("cards-per-column-" + (_vm.currentRound.leftColumn.length))
  }, [_vm.currentRound.subtitle ? _c('div', {
    staticClass: "subtitle"
  }, [_c('h2', [_vm._v("\n            " + _vm._s(_vm.currentRound.subtitle) + "\n          ")])]) : _vm._e(), _c('div', {
    staticClass: "fact"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentRound.fact))])])]) : _vm._e()])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }